var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3748 6.91838C14.0855 6.58868 13.5838 6.55588 13.2541 6.84511L8.99248 10.5837L4.78004 6.78976C4.45415 6.49625 3.95203 6.52249 3.65852 6.84838C3.36501 7.17427 3.39126 7.67639 3.71715 7.9699L8.45409 12.2362C8.75321 12.5056 9.20661 12.5086 9.50923 12.2431L14.3015 8.03904C14.6312 7.74981 14.664 7.24807 14.3748 6.91838Z",
    fill: "#428BF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownButton);
export default __webpack_public_path__ + "static/media/DropdownButton.650e515c990da0f65dabac6998171f05.svg";
export { ForwardRef as ReactComponent };